<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
    <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
    <el-form :label-position="labelPosition" ref="activationCodeForm" :rules="rule" label-width="80px"
             :model="activationCodeForm">
      <div style="background: #FFFFFF;text-align: center">
        <h1 style="width: 100%;height: 30px;line-height: 30px;font-size: 16px;color: #000000;padding: 15px;">使用兑换码</h1>
        <div style="width: 50%;margin: auto;position: relative;padding-bottom: 60px">
          <el-form-item label="兑换码" prop="code">
            <el-input v-model="activationCodeForm.code"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="useActivationCode">(￣▽￣)"</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "UseActivationCode",
  data() {
    return {
      dialogFormVisible: false,
      labelPosition: 'top',
      activationCodeForm: {
        code: ''
      },
      rule: {
        code: [
          {required: true, message: '请输入兑换码', trigger: 'blur'},
          {min: 36, max: 36, message: '请输入正确格式的兑换码', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    useActivationCode() {
      this.$refs['activationCodeForm'].validate((valid) => {
        if (valid) {
          AxiosBase.axiosPost("/property/use-activation_code", this.activationCodeForm).then(response => {
            if (response !== 0) {
              this.dialogFormVisible = false;
              Message({
                showClose: false,
                message: '使用成功',
                type: 'success'
              });
              this.$parent.getProperty();
            }
          })
        }
      });
    }
  }
}
</script>

